const fslightbox = require('fslightbox');
const anchorScroll = require("anchor-scroll");

//plugins
import '../plugins/modernizr/modernizr.min';
import '../plugins/facebook/facebook-sizer';
import {wsMenu} from "../plugins/workshop/ws-menu-v1.0.1/src/js/wksmenu.js";

import AOS from 'aos';
import selectnav from '../plugins/workshop/ws-selectnavjs-v1.0.0/index';

(function () {

	//ANIMATE ON SCROLL INIT
	document.addEventListener('DOMContentLoaded', function () {
		AOS.init();
		document.addEventListener('aos:in', ({ detail }) => {
			console.log('animated in');
		});
	});

	//WS MENU INIT
	document.addEventListener('DOMContentLoaded', function () {

		if (document.querySelector("#main_menu_nav") !== null) {

			let mainMenuNav;
			mainMenuNav = new wsMenu({
				target: '#main_menu_nav',
				addClassNames: true,
				changeToDesktop: "all and (min-width: 1100px)",
				megaMenu: false,
				hover: true,
			});
	}

		if (document.querySelector("aside nav") !== null) {

				let sidebarNav;
				sidebarNav = new wsMenu({
					target: 'aside nav',
					addClassNames: true,
					changeToDesktop: null,
					megaMenu: false,
					squareDropdownButtons: false,
				});
		}
	});

	//ANIMATE ON SCROLL INIT
	document.addEventListener('DOMContentLoaded', function () {

		var selectnavs = document.querySelectorAll('.selectnavjs');
		var selectnavObjects = [];

		selectnavs.forEach(function(nav, index){
			selectnavObjects[index] = new selectnav(nav, {
				label: 'Quicklinks',
			});

			//add label for accessiblity
			var label = document.createElement('LABEL');
			label.setAttribute('for', selectnavObjects[index].id);
			label.innerHTML = 'Quicklinks';
			label.classList.add('sr-only');
			var selectParent = nav.parentElement;
			var select = selectParent.querySelector('select');

			selectParent.insertBefore(label, select);
		});
	});

	//ANCHOR SCROLL
	document.addEventListener('DOMContentLoaded', function () {
		anchorScroll.init({
			updateUrl: true,
			offset: 0,
			ease: 'outQuad',
			duration: 1500,
			selector: '.smooth-scroll' // default a[href*='#']
		});
	});

})();
